<div class="recipe-editor-block" [class.recipe-editor-block--with-bg]="hasBackground()" [class]="customCss()">
  @if (isEditable()) {
    <div class="recipe-options" contenteditable="false">
      <label class="recipe-toggle" dojoStopPropagation>
        <input type="checkbox" [checked]="hasBackground()" (change)="toggleBackground()" />
        <span class="recipe-toggle-label">Background</span>
      </label>
      <span class="add-step-btn" (click)="addStep()" dojoStopPropagation>+ Add step</span>
    </div>

    <input
      class="recipe-title-input"
      type="text"
      placeholder="Add title here..."
      [value]="recipeName()"
      (input)="onNameChange($event)"
      contenteditable="false"
      dojoStopPropagation
    />
  } @else {
    @if (recipeName()) {
      <div class="recipe-title">{{ recipeName() }}</div>
    }
  }

  <div tiptapNodeViewContent></div>
</div>
